import React from 'react';
import { Facebook, Mail, Phone, MapPin } from 'lucide-react';
import { siteInfo, navLinks } from '../mock';

const Footer = () => {
  return (
    <footer className="bg-[#1f2a20] text-[#d6ceba] pt-20 pb-8">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-4 gap-10 pb-14 border-b border-[#3a4a3a]">
          <div className="md:col-span-2">
            <p className="font-display text-3xl text-[#f6efe2] mb-2">Ljungdalens</p>
            <p className="text-[11px] uppercase tracking-[0.3em] text-[#8a8572] mb-6">Turridning</p>
            <p className="font-light leading-relaxed max-w-md text-[#d6ceba]/90">
              Fantastiska ridturer i ljungdalsfjällen. Vi erbjuder hel- och halvdagsturer på fjället med gedigen erfarenhet och omtanke om både hästar och gäster.
            </p>
            <a
              href={siteInfo.facebook}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 mt-6 text-sm hover:text-[#e8d8b4] transition-colors"
            >
              <Facebook className="w-4 h-4" strokeWidth={1.5} />
              Besök vår Facebook-sida
            </a>
          </div>

          <div>
            <p className="text-[11px] uppercase tracking-[0.3em] text-[#8a8572] mb-5">Navigera</p>
            <ul className="space-y-3">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm hover:text-[#e8d8b4] transition-colors">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-[11px] uppercase tracking-[0.3em] text-[#8a8572] mb-5">Kontakt</p>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <Phone className="w-4 h-4 mt-0.5 flex-shrink-0" strokeWidth={1.5} />
                <a href={`tel:${siteInfo.phone}`} className="hover:text-[#e8d8b4] transition-colors">
                  {siteInfo.phone}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="w-4 h-4 mt-0.5 flex-shrink-0" strokeWidth={1.5} />
                <a href={`mailto:${siteInfo.email}`} className="hover:text-[#e8d8b4] transition-colors break-all">
                  {siteInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" strokeWidth={1.5} />
                <span>{siteInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-[#8a8572]">
          <p>Copyright © {new Date().getFullYear()} Ljungdalens Turridning AB. Alla rättigheter förbehållna.</p>
          <p className="italic">Designed with care — for the mountains.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
